<template :style=css>
  <div class="screen-content landscape">
    <div v-html="html"></div>
  </div>
</template>

<script>
export default {
  props: ['message', 'css'],
  data() {
    return {
      html: ''
    }
  },
  created() {
    this.html = '<style>' + this.css + '</style>' + '<h1 class="message">' + this.message + '</h1>'
  },
}
</script>

<style scoped>
.screen-content > div {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>